import React from 'react';
import { NavLink } from 'react-router-dom';
import { MdCircle, MdOutlineLocationOn, MdOutlineBathtub } from 'react-icons/md';
import { BiBed } from 'react-icons/bi';
import { baseUrl } from "../shared/baseUrl";

const PropCard = ({ id, img, category, title, price, beds, baths, address }) => {

  const formatToCurrency = Intl.NumberFormat('en-US')

  return (
    <NavLink to={`/property-details/${id}`} className="available-property_card">
      <div className="ap_card-img">
        <img src={`${baseUrl}/${img}`} alt="Building" />
        <div className="ap_card-tag">
          <MdCircle size={12} />
          <span>For {category}</span>
        </div>
      </div>
      <div className="ap_card-header">
        <h2>{title}</h2>
        <h2><span>₦</span>{formatToCurrency.format(price)}</h2>
      </div>
      <div className="ap_card-body">
        {beds && 
          <div className="ap_card-body-item">
            <BiBed />
            <span>{beds} Beds</span>
          </div>
        }
        {baths && 
          <div className="ap_card-body-item">
            <MdOutlineBathtub />
            <span>{baths} Baths</span>
          </div>
        }
        <div className="ap_card-body-item">
          <MdOutlineLocationOn />
          <span>{address}</span>
        </div>
      </div>
    </NavLink>
  )
}

export default PropCard;